export { curveBasis, curveBasisClosed, curveBasisOpen, curveStep, curveStepAfter, curveStepBefore, curveBundle, curveLinear, curveLinearClosed, curveCardinal, curveCardinalClosed, curveCardinalOpen, curveCatmullRom, curveCatmullRomClosed, curveCatmullRomOpen, curveMonotoneX, curveMonotoneY, curveNatural } from 'd3-shape';



//////////////////
// WEBPACK FOOTER
// /home/circleci/pickle/~/@vx/curve/dist/vx-curve.es.js
// module id = HIv4
// module chunks = 0